<template>
    <div class="relative">
        <select class="input" @change="$emit('input', $event.target.value)">
            <option value="">{{ placeholder || __('Selecione...') }}</option>
            <option
                v-for="(option, optionIndex) in options"
                :key="optionIndex"
                :value="option.value"
                :selected="option.value == value"
            >
                {{ option.label }}
            </option>
        </select>

        <div class="absolute inset-y-0 right-0 mx-2 flex items-center text-secondary">
            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path
                    fill-rule="evenodd"
                    d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                />
            </svg>
        </div>
    </div>
</template>

<script>
import * as Form from '@App/Utils/Form'

export default {
    props: ['field', 'value'],
    computed: {
        options() {
            if (this.field.reference) return this.field.reference.atributos_extras.options
            if (this.field.atributos_extras && this.field.atributos_extras.options)
                return this.field.atributos_extras.options
            return this.field.options || []
        },

        placeholder() {
            return Form.placeholder(this.field)
        },
    },
}
</script>
